<div class="main-wrapper">
  <!-- Header Gobierno -->
  <header>
    <nav class="navbar header-govco">
      <div class="container-fluid" style="height: 60px">
        <a class="navbar-brand" href="https://www.minsalud.gov.co/Portada2021/index.html"> </a>
      </div>
    </nav>

    <!-- Logo IHCE -->
    <div class="logo-container">
      <div class="container text-center">
        <img
          src="/logo_dag.png"
          alt="IHCE - Interoperabilidad de la Historia Clínica Electrónica"
        />
        <h1 class="mt-3 mb-0 fw-bold text-primary" style="font-size: 1.5rem">Visor RDA</h1>
        <p class="text-muted mb-0" style="font-size: 0.9rem">
          Resumen Digital de Atención en Salud
        </p>
      </div>
    </div>
  </header>

  <!-- Contenedor Principal -->
  <div class="content-wrapper">
    <div class="main-container">
      <div class="accordion" id="accordionExample">
        <!-- Formulario de Consulta -->
        @if (!hiddenForm()) {
          <div class="accordion-item card-custom">
            <h2 class="accordion-header">
              <button
                class="accordion-button"
                type="button"
                disabled
                style="cursor: default; pointer-events: none"
              >
                <i class="bx bxs-id-card bx-md icon-style"></i>
                Consulta Información - Resumen Digital de Atención en Salud
              </button>
            </h2>
            <div class="accordion-collapse collapse show">
              <div class="accordion-body">
                <form (ngSubmit)="consultarInformacion()">
                  <div class="row g-3">
                    <div class="col-md-6">
                      <label for="inputDocumento" class="form-label">
                        <i class="bx bx-id-card"></i> Número de Documento
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        id="inputDocumento"
                        [(ngModel)]="numeroDocumento"
                        name="numeroDocumento"
                        placeholder="Ingrese el número de documento"
                        required
                      />
                    </div>
                    <div class="col-md-6">
                      <label for="inputTipoDocumento" class="form-label">
                        <i class="bx bx-file"></i> Tipo de Documento
                      </label>
                      <select
                        class="form-select"
                        id="inputTipoDocumento"
                        [(ngModel)]="tipoDocumento"
                        name="tipoDocumento"
                      >
                        <option value="CC">Cédula de Ciudadanía</option>
                        <option value="TI">Tarjeta de Identidad</option>
                        <option value="CE">Cédula de Extranjería</option>
                        <option value="PA">Pasaporte</option>
                        <option value="RC">Registro Civil</option>
                      </select>
                    </div>

                    <!-- Filtro de Fecha 
                  <div class="col-md-12">
                    <div class="form-check form-switch">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="activarFiltroFecha"
                        [(ngModel)]="activarFiltroFecha"
                        name="activarFiltroFecha"
                      />
                      <label class="form-check-label" for="activarFiltroFecha">
                        <i class="bx bx-filter"></i>
                        <strong>Filtrar documentos desde una fecha específica</strong>
                      </label>
                    </div>
                  </div>-->

                    @if (activarFiltroFecha()) {
                      <div class="col-md-6">
                        <label for="inputFechaDesde" class="form-label">
                          <i class="bx bx-calendar"></i> Fecha desde
                        </label>
                        <input
                          type="date"
                          class="form-control"
                          id="inputFechaDesde"
                          [(ngModel)]="fechaDesde"
                          name="fechaDesde"
                        />
                        <div class="form-text">
                          Solo se mostrarán documentos actualizados desde esta fecha
                        </div>
                      </div>
                    }

                    <div class="col-12">
                      <hr class="my-4" />
                      <div class="d-grid gap-2 d-md-block">
                        <button
                          type="submit"
                          class="btn btn-primary btn-lg"
                          [disabled]="state.loading()"
                        >
                          <i class="bx bx-search-alt"></i> Consultar Información
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-secondary btn-lg ms-md-2"
                          (click)="limpiarFormulario()"
                        >
                          <i class="bx bx-refresh"></i> Limpiar
                        </button>
                      </div>
                    </div>

                    @if (state.error()) {
                      <div class="col-12">
                        <div class="alert alert-danger" role="alert">
                          <i class="bx bx-error-circle"></i> No fué posible obtener la información
                          del paciente. Intente nuevamente.
                        </div>
                      </div>
                    }

                    @if (successMessage()) {
                      <div class="col-12">
                        <div class="alert alert-success" role="alert">
                          <i class="bx bx-check-circle"></i> {{ successMessage() }}
                        </div>
                      </div>
                    }
                  </div>
                </form>
              </div>
            </div>
          </div>
        }

        <!-- Información del Paciente -->
        <div class="accordion-item card-custom">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              (click)="toggleAccordion('patient'); $event.preventDefault()"
            >
              <i class="bx bxs-user bx-md icon-style"></i>
              Información del Paciente
            </button>
          </h2>
          <div [class.show]="accordionStates().patient" class="accordion-collapse collapse">
            <div class="accordion-body">
              @if (state.patientData()) {
                <app-patient-card [patient]="state.patientData()!" />
              } @else {
                <div class="alert alert-info" role="alert">
                  <i class="bx bx-info-circle"></i>
                  No hay información del paciente. Realice una consulta para ver los datos.
                </div>
              }
            </div>
          </div>
        </div>

        <!-- Registros de Vacunación -->
        <div class="accordion-item card-custom">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              (click)="toggleAccordion('immunizations'); $event.preventDefault()"
            >
              <i class="bx bxs-injection bx-md icon-style"></i>
              Registros de Vacunación
              @if (state.contadorVacunas() > 0) {
                <span class="badge bg-warning ms-2">{{ state.contadorVacunas() }}</span>
              }
            </button>
          </h2>
          <div [class.show]="accordionStates().immunizations" class="accordion-collapse collapse">
            <div class="accordion-body">
              @if (state.immunizations().length > 0) {
                <app-immunization-table [immunizations]="state.immunizations()" />
              } @else {
                <div class="alert alert-info" role="alert">
                  <i class="bx bx-info-circle"></i>
                  No hay registros de vacunación. Realice una consulta para ver los datos.
                </div>
              }
            </div>
          </div>
        </div>

        <!-- Encuentros Clínicos -->
        <div class="accordion-item card-custom">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              (click)="toggleAccordion('encounters'); $event.preventDefault()"
            >
              <i class="bx bxs-heart bx-md icon-style"></i>
              Encuentros Clínicos
              @if (documentosEncuentros().length > 0) {
                <span class="badge bg-success text-white ms-2">{{
                  documentosEncuentros().length
                }}</span>
              }
            </button>
          </h2>
          <div [class.show]="accordionStates().encounters" class="accordion-collapse collapse">
            @if (documentosEncuentros().length > 0) {
              <div class="accordion-body" style="max-height: 600px; overflow-y: auto">
                <app-composition-table
                  [entries]="documentosEncuentros()"
                  [referencedResources]="state.referencedResources()"
                  [showSourceBadge]="true"
                  (detalleClick)="mostrarDetalle($event)"
                />
              </div>
            } @else {
              <div class="accordion-body">
                <div class="alert alert-info" role="alert">
                  <i class="bx bx-info-circle"></i>
                  No hay encuentros clínicos registrados. Realice una consulta para ver los datos.
                </div>
              </div>
            }
          </div>
        </div>

        <!-- Historial de Atenciones en Salud Antecedentes manifestados por el paciente -->
        <div class="accordion-item card-custom">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              (click)="toggleAccordion('history'); $event.preventDefault()"
            >
              <i class="bx bxs-clinic bx-md icon-style"></i>
              Historial de Atenciones en Salud Antecedentes manifestados por el paciente
              @if (documentosHistorial().length > 0) {
                <span class="badge bg-warning ms-2">{{ documentosHistorial().length }}</span>
              }
            </button>
          </h2>
          <div [class.show]="accordionStates().history" class="accordion-collapse collapse">
            @if (documentosHistorial().length > 0) {
              <div class="accordion-body" style="max-height: 600px; overflow-y: auto">
                <app-composition-table
                  [entries]="documentosHistorial()"
                  [referencedResources]="state.referencedResources()"
                  (detalleClick)="mostrarDetalle($event)"
                />
              </div>

              <!-- Paginación -->
              @if (state.paginationLinks().length > 0 || canGoBack()) {
                <div class="accordion-body border-top pt-3 pb-2">
                  <div class="d-flex justify-content-center align-items-center flex-wrap gap-2">
                    <!-- Botón Anterior (historial cliente) — siempre disponible si hay historial -->
                    @if (canGoBack()) {
                      <button
                        class="btn btn-outline-secondary btn-sm"
                        (click)="goBack()"
                        [disabled]="state.loading()"
                      >
                        ◀ Anterior
                      </button>
                    }

                    <!-- Spacer — solo si hay ambos lados -->
                    @if (canGoBack() && state.paginationLinks().length > 0) {
                      <span class="text-muted small px-2">|</span>
                    }

                    <!-- Botón Siguiente (link del servidor IHCE) -->
                    @for (link of state.paginationLinks(); track link.url) {
                      @if ((link.relation === 'next' || link.relation === 'last') && link.url) {
                        <button
                          [class]="getPaginationButtonClass(link.relation || '')"
                          (click)="cargarPagina(link.url!)"
                          [disabled]="state.loading()"
                        >
                          {{ getPaginationLabel(link.relation || '') }}
                        </button>
                      }
                    }
                  </div>
                </div>
              }
            } @else {
              <div class="accordion-body">
                <div class="alert alert-info" role="alert">
                  <i class="bx bx-info-circle"></i>
                  No hay historial de atenciones. Realice una consulta para ver los datos.
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Fin del content-wrapper -->

  <!-- Footer -->
  <footer class="footer-govco">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-6">
          <a
            href="https://www.minsalud.gov.co/Portada2021/index.html"
            class="d-flex align-items-center gap-3"
          >
          </a>
        </div>
        <div class="col-md-6 text-end text-white">
          <small>© 2026 DAG Comunicaciones SAS - Soluciones tecnológica e informáticas</small>
        </div>
      </div>
    </div>
  </footer>

  <!-- Modal de Detalle -->
  @if (showModal() && selectedComposition() && state.referencedResources()) {
    <app-detail-modal
      [entry]="selectedComposition()!"
      [referencedResources]="state.referencedResources()!"
      (closeClick)="cerrarModal()"
    />
  }

  <!-- Modal de Carga -->
  @if (state.loading()) {
    <div class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0, 0, 0, 0.5)">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body text-center p-5">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Cargando...</span>
            </div>
            <p class="mt-3 mb-0 fw-bold">Consultando Información...</p>
            <p class="text-muted small">Por favor espere</p>
          </div>
        </div>
      </div>
    </div>
  }
</div>
